import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CompanyWorkflow, CreateTransitionInput, Transition, UpdateTransitionInput, WorkflowPort } from '../domain/workflow'

const createTransition = async (
	port: WorkflowPort,
	input: CreateTransitionInput,
	notify: NotifyPort,
): Promise<Transition | null> => {
	try {
		const transition = await port.createTransition(input)
		notify.success('workflow.transitionCreated')
		return transition
	} catch {
		notify.error('workflow.transitionCreateFailed')
		return null
	}
}

const updateTransition = async (
	port: WorkflowPort,
	input: UpdateTransitionInput,
	notify: NotifyPort,
): Promise<CompanyWorkflow | null> => {
	try {
		const workflow = await port.updateTransition(input)
		notify.success('workflow.transitionUpdated')
		return workflow
	} catch {
		notify.error('workflow.transitionUpdateFailed')
		return null
	}
}

const deleteTransition = async (
	port: WorkflowPort,
	id: string,
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.deleteTransition(id)
		notify.success('workflow.transitionDeleted')
		return true
	} catch {
		notify.error('workflow.transitionDeleteFailed')
		return false
	}
}

export { createTransition, updateTransition, deleteTransition }
